(function (LifecycleHooks) {
    LifecycleHooks[LifecycleHooks["OnInit"] = 0] = "OnInit";
    LifecycleHooks[LifecycleHooks["OnDestroy"] = 1] = "OnDestroy";
    LifecycleHooks[LifecycleHooks["AfterContentInit"] = 2] = "AfterContentInit";
    LifecycleHooks[LifecycleHooks["AfterContentChecked"] = 3] = "AfterContentChecked";
    LifecycleHooks[LifecycleHooks["AfterViewInit"] = 4] = "AfterViewInit";
    LifecycleHooks[LifecycleHooks["AfterViewChecked"] = 5] = "AfterViewChecked";
    LifecycleHooks[LifecycleHooks["_OnChildrenChanged"] = 6] = "_OnChildrenChanged";
})(exports.LifecycleHooks || (exports.LifecycleHooks = {}));
var LifecycleHooks = exports.LifecycleHooks;
/**
 * @internal
 */
exports.LIFECYCLE_HOOKS_VALUES = [
    LifecycleHooks.OnInit,
    LifecycleHooks.OnDestroy,
    LifecycleHooks.AfterContentInit,
    LifecycleHooks.AfterContentChecked,
    LifecycleHooks.AfterViewInit,
    LifecycleHooks.AfterViewChecked,
    LifecycleHooks._OnChildrenChanged
];
(function (ChildrenChangeHook) {
    ChildrenChangeHook[ChildrenChangeHook["FromView"] = 0] = "FromView";
    ChildrenChangeHook[ChildrenChangeHook["FromContent"] = 1] = "FromContent";
})(exports.ChildrenChangeHook || (exports.ChildrenChangeHook = {}));
var ChildrenChangeHook = exports.ChildrenChangeHook;
//# sourceMappingURL=directive_lifecycle_interfaces.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/ng-metadata/src/core/linker/directive_lifecycle_interfaces.js
 ** module id = 10
 ** module chunks = 0
 **/